import React from 'react';

const ErrorFallback = props => {
    const {error, resetErrorBoundary} = props;
    return (
        <div className={'ch-content-error ch-content-main-error'}>
            <div className="ch-content-error">There was an error loading your content. Return to &nbsp;<a href="/dashboard/loadActivityDashboard.action">Dashboard</a></div>
        </div>
    );
}

export default ErrorFallback;